module.exports = __webpack_public_path__ + "static/media/05_messaging.6c7890fe.png";